import {
  FetchListNotificationAction,
  MarkAsReadNotificationAction,
  UpdateShowTermsStatusAction,
  UpdateShowTermsStatusPayload,
  UpdateStateMarkAsReadNotificationAction,
  UpdateStateNotificationAction,
  UpdateStateNotificationPayload,
} from 'types/actions/home';

import { homeConstant } from '../actionTypes';

export const fetchListNotification = (): FetchListNotificationAction => ({
  type: homeConstant.GET_NOTIFICATION,
});

export const getMarkAsReadNotification = (): MarkAsReadNotificationAction => ({
  type: homeConstant.MARK_AS_READ_NOTIFICATION,
});

export const updateStateMarkAsReadNotification = (): UpdateStateMarkAsReadNotificationAction => ({
  type: homeConstant.UPDATE_STATE_MARK_AS_READ_NOTIFICATION,
});

export const updateStateNotification = (
  payload: UpdateStateNotificationPayload
): UpdateStateNotificationAction => ({
  type: homeConstant.UPDATE_STATE_NOTIFICATION,
  payload,
});

export const updateShowTermsStatus = (
  payload: UpdateShowTermsStatusPayload
): UpdateShowTermsStatusAction => ({
  type: homeConstant.UPDATE_SHOW_TERMS_STATUS,
  payload,
});
